import BaseTable from 'components/Tables/BaseTable';
import WidgetLoadingAnimation from 'components/Widgets/WidgetLoadingAnimation';
import { useMemo } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa6';
import { useMaintenanceDeviceContext } from '../../contexts/MaintenanceDeviceProvider/MaintenanceDeviceProvider';
import MaintenanceIFrame from '../MaintenanceIFrame/MaintenanceIFrame';

const MaintenanceDeviceContent = () => {
  const { maintenanceGroups, isLoading, selectedDevice } = useMaintenanceDeviceContext();

  const columns = useMemo(() => {
    return [
      {
        header: 'ID',
        accessorKey: 'id',
        Cell: ({ row, cell }) => {
          const id = cell.getValue();
          return <div className="text-white fs-6">{id}</div>;
        },
      },
      {
        header: 'Name',
        accessorKey: 'name',
        Cell: ({ row, cell }) => {
          const name = cell.getValue();
          return <div className="text-white fs-6">{name}</div>;
        },
      },
      {
        header: 'Devices',
        accessorKey: 'devices',
        Cell: ({ row, cell }) => {
          const devices = cell.getValue();
          return <div className="text-white fs-6">{devices}</div>;
        },
      },
      {
        header: 'Status',
        accessorKey: 'status',
        Cell: ({ row, cell }) => {
          const status = cell.getValue();
          return <div className="text-white fs-6">{status}</div>;
        },
      },
      {
        header: '',
        id: 'Actions',
        columnDefType: 'display',
        enableSorting: false,
        Cell: ({ row }) => {
          const expanded = row.getIsExpanded();
          return (
            <div className="ms-auto">
              {!expanded ? (
                <FaChevronDown size={30} color="white" />
              ) : (
                <FaChevronUp size={30} color="white" />
              )}
            </div>
          );
        },
      },
    ];
  }, []);

  const rows = useMemo(
    () =>
      maintenanceGroups
        .filter((group) => group.deviceCount > 0)
        .map((group) => ({
          id: group.id,
          name: group.name,
          devices: group.deviceCount,
          status: group.status.join(' '),
          devicesArray: group.devices,
        })),
    [maintenanceGroups],
  );

  if (isLoading) {
    return <WidgetLoadingAnimation />;
  }

  return (
    <div className="d-flex flex-column flex-grow-1 min-h-0 overflow-hidden">
      {!selectedDevice && (
        <BaseTable
          columns={columns}
          rows={rows}
          expandable={true}
          customStyles={{
            cell: {
              borderBottom: '1px solid #56577A',
              borderRight: '2px solid #56577A',
              cursor: 'pointer',
            },
            dropdown: { backgroundColor: '#656565' },
          }}
          dropdownMenu={(group) =>
            group.devicesArray.map((device) => (
              <div
                key={device.id}
                className="d-flex align-items-center border-bottom border-1 border-dark p-3 mx-3"
              >
                <p className="flex-grow-1 flex-shrink-1 flex-basis-3xs">{device.id}</p>
                <div className="d-flex flex-column flex-grow-1 flex-shrink-1 flex-basis-3xs">
                  <p className="mb-0">{device.alias}</p>
                  <p className="mb-0" style={{ color: '#A0AEC0' }}>
                    {device.name}
                  </p>
                </div>
                <p className="flex-grow-1 flex-shrink-1 flex-basis-3xs">{device.device_type}</p>
                <p className="flex-grow-1 flex-shrink-1 flex-basis-3xs">{device.status}</p>
              </div>
            ))
          }
        />
      )}
      {selectedDevice && <MaintenanceIFrame />}
    </div>
  );
};

export default MaintenanceDeviceContent;
